import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Table from '@vcomponents/AppTable';
import moment from 'moment';
import { Badge } from 'reactstrap';
import { createColumnHelper } from '@tanstack/react-table';

const STATUS_COLORS = {
  dispatched: 'primary',
  running: 'info',
  success: 'success',
  retrying: 'warning',
  failed: 'danger',
};

const JobHistoryModal = () => {
  const { payload } = useSelector((state) => state.modal);

  const historyTableData = useMemo(() => {
    const history = payload?.history ?? [];

    return {
      data: history.map((item, index) => ({
        ...item,
        id: index + 1,
        attempt: item.attempt ?? index + 1,
        time: item.at ? moment(item.at).format('lll') : 'N/A',
      })),
      from: 1,
      to: history.length,
      total: history.length,
      pageIndex: 0,
      pageSize: history.length,
      pageCount: 1,
      loading: false,
    };
  }, [payload]);

  const columnHelper = createColumnHelper();

  const JobHistoryColumns = () => [
    columnHelper.accessor('attempt', {
      header: 'Attempt',
      cell: ({ row }) => <span className='mr-5'>{row?.original?.attempt}</span>,
    }),
    columnHelper.accessor('status', {
      header: 'Status',
      cell: ({ row }) => {
        const status = row.original.status?.toLowerCase();
        const color = STATUS_COLORS[status] || 'secondary';
        return (
          <Badge color={color} className='text-capitalize'>
            {row.original.status}
          </Badge>
        );
      },
    }),
    columnHelper.accessor('note', {
      header: 'Note',
    }),
    columnHelper.accessor('at', {
      header: 'Time',
      cell: ({ getValue }) =>
        getValue() ? moment(getValue()).format('lll') : 'N/A',
    }),
  ];
  return (
    <Table
      key='job-history-table'
      state={{
        columns: JobHistoryColumns(),
        data: historyTableData,
      }}
      pagination={false}
      actions={{}}
    />
  );
};

export default JobHistoryModal;
